/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import swal from "sweetalert";
import Swal from "sweetalert2";
import BaseUrl from "../../BaseUrl";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";

export const AdvisorQA = () => {
  const token = useSelector((state) => state.auth.auth);
  const [newquestion, setNewquestion] = useState([]);

  const QA_Form = () => {
    // setLoader(true);
    var config = {
      method: "get",
      url: `${BaseUrl.baseurl}/advisor/all/question`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.token}`,
      },
    };

    axios(config)
      .then(function (response) {
        console.log(response);
        if (response?.data?.status === true) {
          setNewquestion(response?.data?.questions);
          Swal.fire({
            showCloseButton: true,
            toast: true,
            icon: "success",
            title: response?.data?.message,
            animation: true,
            position: "top-right",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
        }
      })
      .catch(function (error) {
        console.log(error);
        // setFielderr(error?.response?.data?.errors);
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title: error?.response?.data?.message,
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  };
  useEffect(() => {
    QA_Form();
  }, [1]);

  const [questname] = useState(false);
  const [isIndex, setIsIndex] = useState(0);
  const [radioval, setRadioval] = useState({
    quest0: "",
    quest1: "",
    quest2: "",
    quest3: "",
    quest4: "",
    quest5: "",
    quest6: "",
    quest7: "",
    quest8: "",
    quest9: "",
    quest10: "",
    quest11: "",
    quest12: "",
    quest13: "",
    quest14: "",
    quest16: "",
    quest17: "",
    quest18: "",
    quest19: "",
    quest20: "",
  });
  const [answerid, setAnswerid] = useState("");
  const [qaid, setQaid] = useState("");
  const CheckValue = (e, i) => {
    setRadioval({ ...radioval, [e.target.name]: e.target.value });
  };
  const getquest = (index) => {
    return `quest${index}`;
  };
  const isChecked = (index, quest, qa) => {
    const questname = `quest${index}`;
    return quest === radioval[questname];
  };

  console.log(radioval, questname, "sf");

  //   const Submit = (QuId, AnsID) => {
  //     const form = new FormData();
  //     form.append("professional_page_form_id", localStorage.getItem("userId"));
  //     form.append("question_answer_id", QuId);
  //     form.append("question_option_id", AnsID);

  //     // setLoader(true);
  //     var config = {
  //       method: "post",
  //       url: `${BaseUrl.baseurl}/advisor/question/answer`,
  //       data: form,
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${token.token}`,
  //       },
  //     };

  //     axios(config)
  //       .then(function (response) {
  //         if (response?.data?.status === true) {
  //           Swal.fire({
  //             icon: "success",
  //             title: "Good Job!",
  //             text: "We'll contact you with more information within 2 business days",
  //           });
  //           Swal.fire({
  //             showCloseButton: true,
  //             toast: true,
  //             icon: "success",
  //             title: response?.data?.message,
  //             animation: true,
  //             position: "top-right",
  //             showConfirmButton: false,
  //             timer: 3000,
  //             timerProgressBar: true,
  //             didOpen: (toast) => {
  //               toast.addEventListener("mouseenter", Swal.stopTimer);
  //               toast.addEventListener("mouseleave", Swal.resumeTimer);
  //             },
  //           });
  //           //   history.push("/AdvisorQA");
  //           window.scrollTo({
  //             top: 100000 * 100000,
  //             behavior: "smooth",
  //           });
  //         } else {
  //         }
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //         // setFielderr(error?.response?.data?.errors);
  //         Swal.fire({
  //           showCloseButton: true,
  //           toast: true,
  //           icon: "error",
  //           title: error?.response?.data?.message,
  //           animation: true,
  //           position: "top-right",
  //           showConfirmButton: false,
  //           timer: 3000,
  //           timerProgressBar: true,
  //           didOpen: (toast) => {
  //             toast.addEventListener("mouseenter", Swal.stopTimer);
  //             toast.addEventListener("mouseleave", Swal.resumeTimer);
  //           },
  //         });
  //       });
  //   };
  const Submit = () => {
    const form = new FormData();

    form.append("professional_page_form_id", localStorage.getItem("userId"));
    form.append("question_option_id", Number(answerid));
    form.append("question_answer_id", Number(qaid));

    // setLoader(true);
    var config = {
      method: "post",
      url: `${BaseUrl.baseurl}/advisor/question/answer`,
      data: form,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.token}`,
      },
    };

    axios(config)
      .then(function (response) {
        if (response?.data?.status === true) {
          Swal.fire({
            icon: "success",
            title: "Good Job!",
            text: "We'll contact you with more information within 2 business days",
          });
          Swal.fire({
            showCloseButton: true,
            toast: true,
            icon: "success",
            title: response?.data?.message,
            animation: true,
            position: "top-right",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          //   history.push("/AdvisorQA");
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
        }
      })
      .catch(function (error) {
        console.log(error);
        // setFielderr(error?.response?.data?.errors);
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title: error?.response?.data?.message,
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  };

  const next = () => {
    setIsIndex(isIndex + 1);
  };
  const back = () => {
    setIsIndex(isIndex - 1);
  };
  console.log(qaid, answerid, "newquestion");
  return (
    <>
      <div className="page-wraper">
        <Header />
        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-md-1" />
              <div className="col-md-10 border bg-white rounded-1rem mt-3">
                <div className="mt-5">
                  {newquestion
                    ? newquestion?.map((qa, index) => {
                        return (
                          <>
                            {index === isIndex ? (
                              <>
                                <h4 className="text-center">
                                  {" "}
                                  <span>{index + 1}.</span>
                                  {qa.question}
                                </h4>
                                <div className="row ">
                                  <div className="col-md-1"></div>
                                  <div
                                    className="col-md-10"
                                    onClick={() => setQaid(qa?.id)}
                                  >
                                    {qa?.question_option.map((quest) => (
                                      <div
                                        className={`acod-content border border-radius w-100 ${
                                          radioval[getquest(index)] ===
                                          quest.option
                                            ? "isActive"
                                            : null
                                        }`}
                                      >
                                        <div className="radio-control mt-3 ">
                                          <input
                                            required
                                            id="Yellow"
                                            type="radio"
                                            name={`quest${index}`}
                                            value={quest.option}
                                            onChange={(e) =>
                                              CheckValue(e, index)
                                            }
                                            checked={isChecked(
                                              index,
                                              quest.option,
                                              qa
                                            )}
                                            onClick={() =>
                                              setAnswerid(quest?.id)
                                            }
                                          />
                                          &nbsp;
                                          <label
                                            className=""
                                            style={{ fontSize: 20 }}
                                          >
                                            <p>{quest.option}</p>
                                          </label>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                  <div className="col-md-1"></div>
                                </div>
                                {isIndex === 17 ? (
                                  <Link
                                    to="/"
                                    type="button"
                                    onClick={Submit}
                                    className="site-button float-right my-3 "
                                  >
                                    Submit
                                  </Link>
                                ) : (
                                  <button
                                    type="button"
                                    className="site-button float-right my-3"
                                    onClick={() => {
                                      next();
                                      Submit();
                                    }}
                                  >
                                    Next
                                  </button>
                                )}

                                {isIndex === 0 ? null : (
                                  <button
                                    type="button"
                                    className="site-button float-left my-3"
                                    onClick={back}
                                  >
                                    Back
                                  </button>
                                )}
                              </>
                            ) : null}
                          </>
                        );
                      })
                    : null}
                  <div className="row"></div>
                </div>
              </div>
              <div className="col-md-1" />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
